// Declaration-start detectors for filtering composition candidates.
// Example: `color: red` must not be parsed as selector composition.
import { isIdentifierChar, isIdentifierStart, isPropertyNameChar, isPropertyNameStart, skipWhitespace } from './scanner-chars'

// Detect declaration-like statement starts.
export function startsDeclarationLike(trimmed: string): boolean {
  // Return true when statement starts as CSS/property declaration.
  return startsCustomPropertyDeclaration(trimmed) || startsPropertyDeclaration(trimmed)
}

// Detect custom-property declarations like `--name: value`.
function startsCustomPropertyDeclaration(input: string): boolean {
  let cursor = 0
  // Reject when input does not start with `--`.
  if (input[cursor] !== '-' || input[cursor + 1] !== '-') {
    return false
  } else {
    // Continue custom property declaration scanning.
  }

  cursor += 2
  // Reject when identifier start is invalid.
  if (!isIdentifierStart(input[cursor] ?? '')) {
    return false
  } else {
    // Continue custom property name scanning.
  }

  cursor += 1
  // Consume declaration name characters.
  while (cursor < input.length && isIdentifierChar(input[cursor])) {
    cursor += 1
  }

  cursor = skipWhitespace(input, cursor)
  // Return true when next token is declaration colon.
  return input[cursor] === ':'
}

// Detect standard declaration starts like `color: value`.
function startsPropertyDeclaration(input: string): boolean {
  let cursor = 0
  const first = input[cursor] ?? ''
  // Reject names with invalid first character.
  if (!isPropertyNameStart(first)) {
    return false
  } else {
    // Continue property name scanning.
  }

  cursor += 1
  // Consume property-name characters.
  while (cursor < input.length && isPropertyNameChar(input[cursor])) {
    cursor += 1
  }

  cursor = skipWhitespace(input, cursor)
  // Return true when next token is declaration colon.
  return input[cursor] === ':'
}
